import cn from "classnames";
import { flexRender, Table as ReactTable } from "@tanstack/react-table";
import { PaidMessageSentListRecord } from "./useTable";
import { ReactElement } from "react";
import Table from "oneclick-component/src/components/Table";
import { LoadingSpinner } from "oneclick-component/src/components/LoadingSpinner";
import { ListEmptyView } from "../../components/EmptyView";
import { useTranslation } from "react-i18next";

interface TableProps {
  table: ReactTable<PaidMessageSentListRecord>;
  isLoading: boolean;
  isEmpty: boolean;
}

const TableView = (props: TableProps): ReactElement => {
  const { table, isLoading, isEmpty } = props;
  const { t } = useTranslation();

  return (
    <Table table={table}>
      {isLoading ? (
        <tr className={"h-171"}>
          <td colSpan={table.getVisibleFlatColumns().length}>
            <span className={cn("flex", "justify-center", "items-center")}>
              <LoadingSpinner />
            </span>
          </td>
        </tr>
      ) : null}
      {!isLoading && isEmpty ? (
        <tr className={"h-171"}>
          <td colSpan={table.getVisibleFlatColumns().length}>
            <ListEmptyView
              description={t("paidMessageSentList.table.emptyState")}
            />
          </td>
        </tr>
      ) : null}
      {!isEmpty
        ? table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => {
                return (
                  <td
                    key={cell.id}
                    className={cn("pr-3", "text-sm", "bg-white")}
                    style={{
                      width:
                        cell.column.getSize() === Number.MAX_SAFE_INTEGER
                          ? "auto"
                          : cell.column.getSize(),
                    }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                );
              })}
            </tr>
          ))
        : null}
    </Table>
  );
};

export default TableView;
